// Legacy
const previewOpenEnded = require('@/assets/images/slide-type-preview/open-ended.svg')
const previewWordCloud = require('@/assets/images/slide-type-preview/word-cloud.svg')
const previewScale = require('@/assets/images/slide-type-preview/scales.svg')
const previewQuestion = require('@/assets/images/slide-type-preview/q&a.svg')
const previewPickAnswer = require('@/assets/images/slide-type-preview/pick-answer.svg')
const previewPickImage = require('@/assets/images/slide-type-preview/pick-image.svg')
const previewTypeAnswer = require('@/assets/images/slide-type-preview/type-answer.svg')
const previewHeading = require('@/assets/images/slide-type-preview/heading.svg')
const previewBulletPoints = require('@/assets/images/slide-type-preview/list.svg')
const previewQrcode = require('@/assets/images/slide-type-preview/qr-code.svg')
const previewImage = require('@/assets/images/slide-type-preview/image.svg')
const previewYoutube = require('@/assets/images/slide-type-preview/youtube.svg')
const previewDocument = require('@/assets/images/slide-type-preview/document.svg')
const previewGoogleSlide = require('@/assets/images/slide-type-preview/google-slides.svg')
const previewSpinnerWheel = require('@/assets/images/slide-type-preview/spinner-wheel.svg')
const previewBrainstorm = require('@/assets/images/slide-type-preview/brainstorm.svg')
const previewMatchPairs = require('@/assets/images/slide-type-preview/match-pairs.svg')
// const previewGuessNumber = require('@/assets/images/slide-type-preview/guess-number.svg')
const previewCorrectOrder = require('@/assets/images/slide-type-preview/correct-order.svg')
const previewPoll = require('@/assets/images/slide-type-preview/poll.svg')
const previewContent = require('@/assets/images/slide-type-preview/content.svg')

// French Image
const previewOpenEndedFr = require('@/assets/images/slide-type-preview/fr/open-ended.svg')
const previewWordCloudFr = require('@/assets/images/slide-type-preview/fr/word-cloud.svg')
const previewScaleFr = require('@/assets/images/slide-type-preview/fr/scales.svg')
const previewQuestionFr = require('@/assets/images/slide-type-preview/fr/q&a.svg')
const previewPickAnswerFr = require('@/assets/images/slide-type-preview/fr/pick-answer.svg')
const previewPickImageFr = require('@/assets/images/slide-type-preview/fr/pick-image.svg')
const previewTypeAnswerFr = require('@/assets/images/slide-type-preview/fr/type-answer.svg')
const previewHeadingFr = require('@/assets/images/slide-type-preview/fr/heading.svg')
const previewBulletPointsFr = require('@/assets/images/slide-type-preview/fr/list.svg')
const previewQrcodeFr = require('@/assets/images/slide-type-preview/fr/qr-code.svg')
const previewImageFr = require('@/assets/images/slide-type-preview/fr/image.svg')
const previewYoutubeFr = require('@/assets/images/slide-type-preview/fr/youtube.svg')
// const previewDocumentFr = require('@/assets/images/slide-type-preview/fr/document.svg')
const previewGoogleSlideFr = require('@/assets/images/slide-type-preview/fr/google-slides.svg')
const previewSpinnerWheelFr = require('@/assets/images/slide-type-preview/fr/spinner-wheel.svg')
const previewBrainstormFr = require('@/assets/images/slide-type-preview/fr/brainstorm.svg')
const previewMatchPairsFr = require('@/assets/images/slide-type-preview/fr/match-pairs.svg')
const previewCorrectOrderFr = require('@/assets/images/slide-type-preview/fr/correct-order.svg')
const previewPollFr = require('@/assets/images/slide-type-preview/fr/poll.svg')
const previewContentFr = require('@/assets/images/slide-type-preview/fr/content.svg')

// AHA-20221: New Slide Type Previews (visual preview)
const previewVisualBrainstorm = require('@/assets/images/slide-type-preview/visual/brainstorm.webm')
const previewVisualContent = require('@/assets/images/slide-type-preview/visual/content.svg')
const previewVisualCorrectOrder = require('@/assets/images/slide-type-preview/visual/correct-order.webm')
const previewVisualGoogleSlide = require('@/assets/images/slide-type-preview/visual/google-slides.svg')
const previewVisualHeading = require('@/assets/images/slide-type-preview/visual/heading.svg')
const previewVisualImage = require('@/assets/images/slide-type-preview/visual/image.svg')
const previewVisualList = require('@/assets/images/slide-type-preview/visual/list.svg')
const previewVisualMatchPairs = require('@/assets/images/slide-type-preview/visual/match-pair.webm')
const previewVisualOpenEnded = require('@/assets/images/slide-type-preview/visual/open-ended.webm')
const previewVisualPickAnswer = require('@/assets/images/slide-type-preview/visual/pick-answer.webm')
const previewVisualPickImage = require('@/assets/images/slide-type-preview/visual/pick-image.webm')
const previewVisualPoll = require('@/assets/images/slide-type-preview/visual/poll.webm')
const previewVisualQuestion = require('@/assets/images/slide-type-preview/visual/q&a.webm')
const previewVisualQrCode = require('@/assets/images/slide-type-preview/visual/qr-code.svg')
const previewVisualScale = require('@/assets/images/slide-type-preview/visual/scales.webm')
const previewVisualShortAnswer = require('@/assets/images/slide-type-preview/visual/short-answer.webm')
const previewVisualSpinnerWheel = require('@/assets/images/slide-type-preview/visual/spinner-wheel.webm')
const previewVisualWordCloud = require('@/assets/images/slide-type-preview/visual/word-cloud.webm')
const previewVisualYoutube = require('@/assets/images/slide-type-preview/visual/youtube.svg')

export const VISUAL_TYPE = {
  IMAGE: 'image',
  VIDEO: 'video',
}

const slideTypes = [
  {
    title: 'Quiz and games',
    sectionLabel: 'Quiz',
    sectionIcon: 'mti-check',
    sectionKey: 'quiz',
    desc: 'Ask quiz questions, or play games, and let your participants compete for victory!',
    slideTypes: [
      {
        name: 'Pick Answer',
        icon: 'fas fa-tasks',
        type: 'pickAnswer',
        slideType: null,
        desc: 'Ask a quiz question and write the options. Participants try to choose the correct answer to score points.',
        label: 'Quiz',
        ahaIcon: 'pick-answer',
        ahaIconWhite: 'pick-answer-w',
        preview: 'pickAnswer',
        previewUrl: previewPickAnswer,
        previewUrlFr: previewPickAnswerFr,
        previewUrlVisual: previewVisualPickAnswer,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/RGX2dmuvTEA',
      },
      {
        name: 'Pick Image',
        icon: 'fas fa-images',
        type: 'pickAnswer',
        slideType: 'imageChoice',
        desc: 'Ask a quiz question and provide image options. Participants try to choose the correct image to score points.',
        label: 'Quiz',
        ahaIcon: 'pick-image',
        ahaIconWhite: 'pick-image-w',
        preview: 'pickImage',
        previewUrl: previewPickImage,
        previewUrlFr: previewPickImageFr,
        previewUrlVisual: previewVisualPickImage,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/RGX2dmuvTEA',
      },
      {
        name: 'Short Answer',
        icon: 'fas fa-keyboard',
        type: 'pickAnswer',
        slideType: 'typeAnswer',
        desc: 'Ask a quiz question and write in the answer(s) that you will accept. Participants try to write the correct answer and will score points if it matches your accepted answer(s).',
        label: 'Quiz',
        ahaIcon: 'type-answer',
        ahaIconWhite: 'type-answer-w',
        ahaIconTest: 'mti-type-answer',
        ahaIconTestWhite: 'mti-type-answer-w',
        preview: 'typeAnswer',
        previewUrl: previewTypeAnswer,
        previewUrlFr: previewTypeAnswerFr,
        previewUrlVisual: previewVisualShortAnswer,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/LOTd2BLgPgw',
      },
      {
        name: 'Spinner Wheel',
        icon: 'fas fa-keyboard',
        type: 'spinnerWheel',
        desc: 'Ask quiz questions, or play games, and let your participants compete for victory!',
        label: '',
        ahaIcon: 'spinner-wheel',
        ahaIconWhite: 'spinner-wheel-w',
        preview: 'spinnerWheel',
        previewUrl: previewSpinnerWheel,
        previewUrlFr: previewSpinnerWheelFr,
        previewUrlVisual: previewVisualSpinnerWheel,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/-PaqZrxnDOw',
      },
      {
        name: 'Match Pairs',
        type: 'pickAnswer',
        slideType: 'matchPairs',
        desc: 'Pose a question and provide prompts and answers. Participants try to match each prompt to its accompanying answer.',
        label: 'Quiz',
        ahaIcon: 'match-pairs',
        ahaIconWhite: 'match-pairs-w',
        preview: 'matchPairs',
        previewUrl: previewMatchPairs,
        previewUrlFr: previewMatchPairsFr,
        previewUrlVisual: previewVisualMatchPairs,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/0qvPBJcxvYo',
      },
      {
        name: 'Correct Order',
        type: 'pickAnswer',
        slideType: 'correctOrder',
        desc: 'Provide up to 10 mixed-up options and let participants order them.',
        label: 'Quiz',
        ahaIcon: 'correct-order',
        ahaIconWhite: 'correct-order-w',
        preview: 'correctorder',
        previewUrl: previewCorrectOrder,
        previewUrlFr: previewCorrectOrderFr,
        previewUrlVisual: previewVisualCorrectOrder,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/wNCbN-Q7UY8',
      },
      {
        name: 'Leaderboard',
        type: 'leaderboard',
        noType: true,
      },
    ],
  },
  {
    title: 'Opinion and Q&A',
    sectionLabel: 'Collect opinions - Q&A',
    sectionIcon: 'mti-comment',
    sectionKey: 'poll',
    desc: 'Collect opinions from your audience in a range of formats, or address their questions through a Q&A slide!',
    slideTypes: [
      {
        name: 'Poll',
        icon: 'fas fa-signal',
        type: 'imageChoice',
        desc: 'Pose a question, provide the options and let participants choose one or more. You can also add images',
        ahaIcon: 'multiple-choice',
        ahaIconWhite: 'multiple-choice-w',
        preview: 'poll',
        previewUrl: previewPoll,
        previewUrlFr: previewPollFr,
        previewUrlVisual: previewVisualPoll,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/d1NwuHPi_Yo',
      },
      {
        name: 'Open Ended',
        icon: 'fas fa-comment-dots',
        type: 'openEnded',
        desc: 'Pose a question and let participants freely write their responses. Set fields for participants´ names, teams, emails or avatars.',
        ahaIcon: 'open-ended',
        ahaIconWhite: 'open-ended-w',
        preview: 'openEnded',
        previewUrl: previewOpenEnded,
        previewUrlFr: previewOpenEndedFr,
        previewUrlVisual: previewVisualOpenEnded,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/O7o7j4BZDDc',
      },
      {
        name: 'Word Cloud',
        type: 'wordCloud',
        icon: 'fas fa-cloud',
        desc: 'Pose a question and let participants write 1 or 2-word answers. The more popular an answer is, the larger it will appear on screen.',
        ahaIcon: 'word-cloud',
        ahaIconWhite: 'word-cloud-w',
        preview: 'wordCloud',
        previewUrl: previewWordCloud,
        previewUrlFr: previewWordCloudFr,
        previewUrlVisual: previewVisualWordCloud,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/fAIi4n1V8yk',
      },
      {
        name: 'Scales',
        type: 'scale',
        icon: 'fas fa-sliders-h',
        desc: 'Pose a question, write statements and let your participants rate each statement on a scale. Results are shown in a colour-coded graph that shows the popularity of each statement.',
        ahaIcon: 'scales',
        ahaIconWhite: 'scales-w',
        preview: 'scale',
        previewUrl: previewScale,
        previewUrlFr: previewScaleFr,
        visualType: VISUAL_TYPE.VIDEO,
        previewUrlVisual: previewVisualScale,
        videoTutorialUrl: 'https://www.youtube.com/embed/1Iamxm2iJeM',
      },
      {
        name: 'Brainstorm',
        type: 'ideas',
        icon: 'fas fa-comment',
        iconInside: true,
        desc: 'Provide a topic and let the audience submit their ideas. Each participant votes for their favourite ideas and the results are ranked by popularity.',
        ahaIcon: 'brainstorm',
        ahaIconWhite: 'brainstorm-white',
        preview: 'brainstorm',
        previewUrl: previewBrainstorm,
        previewUrlFr: previewBrainstormFr,
        previewUrlVisual: previewVisualBrainstorm,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/JaxWbKImUcQ',
      },
      {
        name: 'Q&A',
        type: 'question',
        icon: 'fas fa-comment',
        iconInside: true,
        desc: 'Participants write and vote on questions for you to answer. All questions are displayed on screen for you to address one by one. Pin questions to save them or mark as answered to remove them.',
        ahaIcon: 'qa',
        ahaIconWhite: 'q&a-w',
        preview: 'question',
        previewUrl: previewQuestion,
        previewUrlFr: previewQuestionFr,
        previewUrlVisual: previewVisualQuestion,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/Z1kCoy9i6N0',
      },
    ],
  },
  {
    title: 'Content slide',
    sectionLabel: 'Content',
    sectionIcon: 'mti-content',
    sectionKey: 'content',
    desc: 'Add text content, image, video... to your presentation',
    slideTypes: [
      {
        name: 'Content',
        type: 'freestyle',
        desc: 'Add and edit text, images and bullet points.',
        ahaIcon: 'content',
        ahaIconWhite: 'content-w',
        preview: 'content',
        previewUrl: previewContent,
        previewUrlFr: previewContentFr,
        previewUrlVisual: previewVisualContent,
        visualType: VISUAL_TYPE.IMAGE,
      },
      {
        name: 'Heading',
        subheading: 'Subheading',
        type: 'textSlide',
        desc: 'Write a heading and an optional subheading. You can use this for introducing a question or quiz slide. This slide type also works great as an opening to a new section of the presentation.',
        ahaIcon: 'heading',
        ahaIconWhite: 'heading-w',
        preview: 'heading',
        previewUrl: previewHeading,
        previewUrlFr: previewHeadingFr,
        previewUrlVisual: previewVisualHeading,
        visualType: VISUAL_TYPE.IMAGE,
      },
      {
        name: 'List',
        type: 'bulletPoints',
        html: '<i class="fas fa-list bulletPoints-icon"></i>',
        desc: 'Write a bullet point list. You can also add a heading and a subheading.',
        ahaIcon: 'list',
        ahaIconWhite: 'list-w',
        preview: 'bulletPoints',
        previewUrl: previewBulletPoints,
        previewUrlFr: previewBulletPointsFr,
        previewUrlVisual: previewVisualList,
        visualType: VISUAL_TYPE.IMAGE,
      },
      {
        name: 'Image',
        type: VISUAL_TYPE.IMAGE,
        icon: 'far fa-image',
        desc: 'Display an image either centrally on the slide or full-screen. Use your own images or choose ones from our library.',
        ahaIcon: 'type-image',
        ahaIconWhite: 'image-w',
        preview: VISUAL_TYPE.IMAGE,
        previewUrl: previewImage,
        previewUrlFr: previewImageFr,
        previewUrlVisual: previewVisualImage,
        visualType: VISUAL_TYPE.IMAGE,
      },
      {
        name: 'QR Code',
        type: 'qrcode',
        icon: 'fas fa-qrcode',
        desc: 'Display the unique QR code for your presentation. Participants can scan this on their devices to join your quiz. Tip: You can also show this QR code on any other slide types by clicking the top of your slide.',
        ahaIcon: 'qr-code',
        ahaIconWhite: 'qr-code-w',
        preview: 'qrcode',
        previewUrl: previewQrcode,
        previewUrlFr: previewQrcodeFr,
        previewUrlVisual: previewVisualQrCode,
        visualType: VISUAL_TYPE.IMAGE,
      },
      {
        name: 'YouTube',
        type: 'youtube',
        icon: 'fab fa-youtube',
        desc: 'Embed a YouTube video. Simply copy and paste the YouTube URL into the slide.',
        ahaIcon: 'youtube',
        ahaIconWhite: 'youtube-w',
        preview: 'youtube',
        previewUrl: previewYoutube,
        previewUrlFr: previewYoutubeFr,
        previewUrlVisual: previewVisualYoutube,
        visualType: VISUAL_TYPE.IMAGE,
      },
      {
        name: 'Google Slides',
        type: 'googleSlides',
        icon: 'fab fa-google',
        desc: 'Embed a Google Slides presentation. The entire slideshow will be displayed within this one slide.',
        ahaIcon: 'google-slides',
        ahaIconWhite: 'google-slides-w',
        preview: 'googleSlides',
        previewUrl: previewGoogleSlide,
        previewUrlFr: previewGoogleSlideFr,
        previewUrlVisual: previewVisualGoogleSlide,
        visualType: VISUAL_TYPE.IMAGE,
      },
      {
        name: 'Document',
        type: 'document',
        icon: 'fas fa-file-import',
        desc: 'Import a PowerPoint or PDF document into this presentation.',
        ahaIcon: 'document',
        ahaIconWhite: 'document-w',
        preview: 'document',
        previewUrl: previewDocument,
        previewUrlFr: previewDocument,
        visualType: VISUAL_TYPE.IMAGE,
        hidden: true,
      },
    ],
  },
]

export default slideTypes
